import { Reveal, Counter } from "../lib/motion";

const STATS = [
  { value: <><span>$</span><Counter to={100} suffix="M+" /></>, label: "Programs Delivered", sub: "Capital deployed across critical infrastructure." },
  { value: <><Counter to={8} /></>, label: "Industries Served", sub: "Government to defense to hyperscale tech." },
  { value: <><Counter to={25} suffix="+" /></>, label: "Years Leadership", sub: "Senior operators, not junior generalists." },
  { value: <><Counter to={99.9} decimals={1} suffix="%" /></>, label: "Uptime Engineered", sub: "Mission-critical systems, always on." },
];

export default function Results() {
  return (
    <section
      id="results"
      className="relative border-t border-white/5 bg-nexis-bg/85 py-28 backdrop-blur-sm md:py-40"
      data-testid="results-section"
    >
      <div className="orb orb-blue left-1/2 top-0 h-[420px] w-[420px] -translate-x-1/2" />
      <div className="mx-auto max-w-7xl px-6 text-center md:px-12">
        <Reveal>
          <span className="font-mono text-xs tracking-[0.25em] text-nexis-blue">— IMPACT & RESULTS</span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mx-auto mt-6 max-w-3xl font-display text-4xl font-light tracking-tight lg:text-6xl">
            Outcomes that <span className="text-gradient">compound</span>.
          </h2>
        </Reveal>

        <div className="mt-20 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {STATS.map((s, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="glass glass-hover flex h-full flex-col items-start rounded-3xl p-8 text-left" data-testid={`result-${i}`}>
                <div className="font-display text-5xl font-semibold tracking-tighter text-white lg:text-6xl">
                  {s.value}
                </div>
                <div className="mt-4 font-display text-base font-medium text-white/90">{s.label}</div>
                <div className="mt-2 text-sm leading-relaxed text-white/45">{s.sub}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
